// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { fontConfig } from "@ces/XDL/PreStyle/typography";
import { xBaseTheme } from "@ces/XDL/types";
import color from "@ces/XDL/Utilities/color";
import { StyledButton } from "@insite/mobius/Clickable";
import { IconWrapper } from "@insite/mobius/Icon";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { css } from "styled-components";

export default {
    defaultProps: {
        mergeCss: true,
        typographyProps: {
            size: 14,
            color: "common.ui6",
            ellipsis: true,
            weight: fontConfig.weight.regular,
            css: css`
                letter-spacing: 0;
                line-height: 22px;
                max-width: 100ch;
                ${IconWrapper} {
                    opacity: 0.5;
                    color: inherit;
                }
            `,
        },
        css: css`
            flex-wrap: wrap;
            margin-top: 12px;
            margin-bottom: 20px;
            gap: 8px;
            ${TypographyStyle} {
                margin: 0;
            }
            > ${TypographyStyle} {
                max-width: calc(50% - 12px);
            }
            ${StyledButton} {
                position: relative;
                overflow: hidden;
                max-width: calc(50% - 12px);
            }
            ${StyledButton} > ${TypographyStyle} {
                color: ${color("common.ui6")};
            }

            ${StyledButton}:hover > ${TypographyStyle} {
                color: ${color("text.link")};
            }
        `,
    },
} as xBaseTheme["breadcrumbs"];
